import axios from '@/libs/api.request'

/**
 * 获取角色与菜单的数据
 */
export const getRoleMenuData = (roleId) => {
    const data = {
        'roleId': roleId
    }
    return axios.request({
        url: '/api/admin/role/jurisdiction',
        data,
        method: 'post'
    })
}

/**
 * 复制角色
 */
 export const copyRole = (roleId) => {
    const data = {
        'id': roleId
    }
    return axios.request({
        url: '/api/admin/role/copy',
        data,
        method: 'post'
    })
}
/**
 * 分配角色
 */
 export const allocation = (org_id, role_ids) => {
    const data = {
        'org_id': org_id,
        'role_ids': role_ids
    }
    return axios.request({
        url: '/api/admin/orgrole/allocation',
        data,
        method: 'post'
    })
}